import { Pagination } from './table.component';

export interface ServerDatatableInterface {
	dataChangePaginate(queryFilter: Pagination): void;

	dataChangeSearchFilter(value?: string): void;

	getSearchFieldKeys(): string[];

	dataChangeCustomFilter(customerFilters: object): void;
}
